import React, { useContext } from 'react'
import { LocalContext } from '../../helpers/useLocalContext'
import { isSEOPage } from '../../helpers/searchBoxFactory'

const LinkMiddleware = ({ children, ...props }) => {
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const propsDefault = props || {}

  if (!__BROWSER__) {
    return <Link {...propsDefault}>{children}</Link>
  }

  const { pageType } = window
  const hasSEOPage = isSEOPage(pageType)
  const propsData = hasSEOPage ? { ...propsDefault, skip: true } : propsDefault

  return <Link {...propsData}>{children}</Link>
}

export default LinkMiddleware
